import * as React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import renderHTML from 'react-render-html';
import { fetchPageWP } from '../actions/pages';
import { getCookie } from '../helpers/index';

class HomeCenterFeatures extends React.Component<any, any> {

    componentDidMount() {
        this.props.fetchPageWP({
            number: 100,
            post_type: 'page'
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pagesWP.loading == false) {
            this.setState({
                loading: false
            })
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.pagesWP.loading) {
            return false;
        } else {
            return true;
        }
    }

	render() {

        const { pagesWP } = this.props;
        var post_content = '';
        var language = 'vn';

        if(getCookie('language_landing')) {
            language = getCookie('language_landing');
        }
        if(pagesWP.data.length > 0) {
            pagesWP.data.map(item => {
                if(item.menu_order == 1) {
                    if(item.custom_fields.length > 0) {
                        item.custom_fields.map(ln => {
                            if(ln.key == 'language' && ln.value == language) {
                                post_content = item.post_content;
                            }
                        })
                    }
                }
            })
        }

		return (
			<div className="content-responsive">
                {renderHTML(`${post_content}`)}
			</div>
		);
	}
}

export default connect(mapStateToProps([
    'pagesWP'
]), mapDispatchToProps({
    fetchPageWP
}))(translate('translations')(HomeCenterFeatures));




// WEBPACK FOOTER //
// ./src/components/HomeCenterFeatures.tsx